import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { Link } from 'react-router-dom';

type State = {
    responseId?: string;
    surveyResponseInventoryId?: string;
}

interface RedirectLinkProps {
    pathname?: string | undefined;
    state?: State;
    localizer: IStringLocalizer;
    handleClickImport?: () => void;
}

export class RedirectLink extends React.PureComponent<RedirectLinkProps> {
    public render() {
        return (
            <Link id="link-to-my-passports" to={{
                pathname: this.props.pathname,
                state: {
                    responseId: this.props.state?.responseId,
                    surveyResponseInventoryId: this.props.state?.surveyResponseInventoryId
                }
            }}>

                <div className="selector-div" onClick={this.props.handleClickImport}>
                    {<div className="title">{this.props.localizer.localizeString("Select from My Passports")}</div>}
                    <div className="description">{this.props.localizer.localizeString("Choose my existing Digital Product Passports")}</div>
                </div>
            </Link>
        );
    }
}